(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function getActiveTemplateKey(section) {
    var hasDesktopTemplate = !!section.querySelector('[data-products-media-template="desktop"]');
    var hasMobileTemplate = !!section.querySelector('[data-products-media-template="mobile"]');

    if (mobileQuery.matches && hasMobileTemplate) {
      return 'mobile';
    }

    if (hasDesktopTemplate) {
      return 'desktop';
    }

    if (hasMobileTemplate) {
      return 'mobile';
    }

    return '';
  }

  function readTemplateHtml(template) {
    if (!template) {
      return '';
    }

    try {
      return JSON.parse(template.textContent);
    } catch (error) {
      return '';
    }
  }

  function renderActiveMedia(section) {
    if (!section) {
      return;
    }

    var stage = section.querySelector('[data-products-media-stage]');

    if (!stage) {
      return;
    }

    var activeKey = getActiveTemplateKey(section);

    if (!activeKey) {
      stage.innerHTML = '';
      stage.dataset.activeTemplate = '';
      return;
    }

    if (stage.dataset.activeTemplate === activeKey) {
      return;
    }

    var template = section.querySelector('[data-products-media-template="' + activeKey + '"]');

    if (!template) {
      return;
    }

    stage.innerHTML = readTemplateHtml(template);
    stage.dataset.activeTemplate = activeKey;
  }

  function initAll(scope) {
    var sections = (scope || document).querySelectorAll('.mt-products-services');

    sections.forEach(function (section) {
      renderActiveMedia(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', function () {
      initAll(document);
    });
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(function () {
      initAll(document);
    });
  }
})();
